/* CDB Product Card
   - Quantity behavior is centralized in cdb-cart-quantity.js
   - Entire product card is clickable except interactive controls
*/

(() => {
  const INTERACTIVE_SELECTOR = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'form',
    'quantity-input',
    'cart-remove-button',
    '[role="button"]',
    '[data-cdb-qty]',
    '[data-cdb-shared-qty]',
    '[data-cdb-pdp-add]'
  ].join(',');

  document.addEventListener('click', (event) => {
    const card = event.target.closest('.cdb-product-card');
    if (!card) return;

    // Let buttons, quantity controls and existing links work normally.
    if (event.target.closest(INTERACTIVE_SELECTOR)) return;

    const productLink =
      card.querySelector('a[id^="CardLink-"]') ||
      card.querySelector('a.full-unstyled-link');

    if (!productLink?.href) return;

    window.location.href = productLink.href;
  });

  document.addEventListener('cdb:cart-updated', () => {
    document
      .querySelectorAll('.cdb-collection-template [data-cdb-shared-qty]')
      .forEach((input) => {
        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('pattern', '[0-9]*');
        input.setAttribute('enterkeyhint', 'done');
      });
  });
})();
